import { supportRepository } from '../repositories/support-repository';

async function sendGuestSupportForm(body) {
    if (!body.email) {
        throw Error('Cannot get email');
    }

    if (!body.message) {
        throw Error('Cannot get message');
    }

    return supportRepository.send(body);
}

export {
    sendGuestSupportForm
};
